<template>
  <section class="scrollable padder">
    <div v-if="loading" class="loading">Loading&#8230;</div>
    <div v-if="showAlert" class="alert alert-danger alert-dismissible">
      <button
        type="button"
        class="close"
        aria-hidden="true"
        @click="closeAlert"
      >
        ×
      </button>
      <h4><i class="icon fa fa-ban"></i> Error!</h4>
      {{ errMessage }}
    </div>
    <section class="panel panel-default">
     
      <div class="modal-body">
        <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addEditCategory)" method="post">
            
          <div class="col-sm-12">
             <ValidationProvider
               name="Category Name"
                  rules="required|alpha"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="category">
                Category Name <span class="required-color">*</span></label
              >
              <input
                type="text"
                id="category"
                class="form-control"
                v-model="categoryName"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid name"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Category Name"
              />
               <span style="color:red">{{ errors[0] }}</span>
            </div>
          
                </ValidationProvider>
          </div>

          <div class="modal-footer" style="text-align: right">
           
            <button
              :disabled="saveCat"
              id="btn_save"
              type="submit"
              class="btn btn-success  text-center  "
            >
              Save
            </button>
             <a
              v-on:click="$emit('hide-category')"
              class="btn btn-danger  text-center  "
            >
              Close
            </a>
          </div>
        </form>
        </ValidationObserver>
      </div>
      
    </section>
  </section>
</template>

<script>
import api from "../api";

export default {
  props: ["categoryId"],
  name: "AddCategory",
  data() {
    return {
      saveCat: false,
      parent_id: "0",
      category_id: '',
      categoryList: [],
      errors : [],
      categoryName: "",
      baseUrl: this.$store.state.baseURL,
      showCatDropdown: false,
      loading: false,
    };
  },
  components: {},
  methods: {
    addEditCategory() {
       this.loading = false
      this.saveCat = true;
      this.category_id = this.$props.categoryId;
      this.errors = []
      if (!this.categoryName) {
        this.errors.push("Category Name required.");
      }
      if(!this.errors.length){
      const addCategory = {
        "category-form": {
          category_id: this.category_id,
          category_name: this.categoryName
          /*,
          sort_order: this.sort_order,
          color_code: this.color_code,
          category_image: this.category_image,*/
        },
      };
      if (this.category_id > 0) {
        api
          .request("post", "GeneralApis/edit_category", addCategory)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Updated");
              this.$emit("hide-category");
              this.$emit("list-category");
            }
          });
      } else {
        api
          .request("post", "GeneralApis/add_category", addCategory)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Added");
              this.$emit("hide-category");
              this.$emit("list-category");
            }
          });
      }
      }
    },
    getCategory: function() {
      var categoryid = this.$props.categoryId;
      (this.categoryList = []),
        (this.categoryName = ""),/*
        (this.sort_order = ""),
        (this.color_code = ""),
        (this.fileContent = ""),*/
        (this.category_id = 0);
      if (categoryid > 0) {
        this.category_id = categoryid;

        const getlist = {
          filter: {
            category_id: this.category_id,
          },
        };
        api
          .request("post", "GeneralApis/get_category", getlist)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              this.categoryList = data.categoryList[0];
              this.categoryName = this.categoryList.category_name;/*
              this.sort_order = this.catlist.sort_order;
              this.color_code = this.catlist.color_code;
              this.fileContent = this.baseUrl + this.catlist.category_image;*/
            }
          });
      }
    },
  },
  mounted() {
    this.getCategory();
  },
};
</script>
